'use client';
import useAspidaSWR from '@aspida/swr';
import { useContext, useEffect } from 'react';
import { SHIPMENT_SUPPORT_COUNTRYS } from '~/constants/shippings';
import { apiClient } from '~/lib/apiClient';
import { isArcApiError } from '~/src/services/errors';
import { isActiveToken } from '~/src/services/users';
import { RootContext } from '~/store';
import type { DeliveryBundle } from '~/types/resources/deliveryBundle';

type UseGachaDeliveryBundles = {
  deliveryBundles: DeliveryBundle[];
  error: any;
};

export const useGachaDeliveryBundles = (
  gacha_id: string | null,
  country: (typeof SHIPMENT_SUPPORT_COUNTRYS)[number]
): UseGachaDeliveryBundles => {
  const { token, loggedInState } = useContext(RootContext);
  const { data, mutate, error } = useAspidaSWR(
    apiClient.v1.gachas._gachaId(gacha_id as string).delivery_bundles,
    {
      headers: {
        Authorization: `Bearer ${token?.token}`,
      },
      query: {
        country,
      },
      isPaused: () =>
        !isActiveToken(token) ||
        loggedInState === 'loading' ||
        gacha_id == null,
    }
  );

  useEffect(() => {
    mutate();
  }, [token]);

  const isDataError = isArcApiError(data);

  return {
    deliveryBundles: data ?? [],
    error: isDataError ? data : error,
  };
};
